import { createFileRoute } from "@tanstack/react-router";
import { StaffInvite } from "@/components/signin/StaffInvite";

export const Route = createFileRoute("/invite/$token")({
  component: InvitePage,
});

function InvitePage() {
  const { token } = Route.useParams();
  return <StaffInvite token={token} />;
}
